import React, { useEffect, useRef, useState } from "react";
import PromoBanner from "../components/PromoBanner";
import reloadImage from "../assets/reload.png";
import searchImage from "../assets/search_icon.png";
import micImageImage from "../assets/mic.png";
import maleProfileImage from "../assets/male.png";
import femaleProfileImage from "../assets/female.png";
import micOnImage from "../assets/mic_on.png";
import micOffImage from "../assets/mic_off.png";
import callCutImage from "../assets/cut_call.png";
import callAddImage from "../assets/add_call.png";
import CircularWaveAnimation from "../components/CircularWaveAnimation";
import { useNavigate } from "react-router-dom";
import {
  LocalUser,
  RemoteUser,
  useIsConnected,
  useJoin,
  useLocalMicrophoneTrack,
  usePublish,
  useRemoteUsers,
  useRTCClient,
  useClientEvent,
} from "agora-rtc-react";
import {
  AgoraEndApi,
  AgoraStartApi,
  GetFriendDetailsApi,
  GetUserByIdApi,
} from "../services/Api";
import { FormatTime } from "../services/Helper";

const TalkingPage = () => {
  const navigate = useNavigate();
  const headerText = `So as long as you can sweeten another's pain, life is not in vain`;
  const [wave, setWave] = useState(true);
  const [isMute, setIsMute] = useState(false);
  const isConnected = useIsConnected();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const totalAudioTalkTime = userData.audioTalkTime;
  const name = userData.name;
  const client = useRTCClient();

  const [calling, setCalling] = useState(false); // Is calling
  const [appId, setAppId] = useState("c8cee9b7eb724c3a95feeeb9c39e77d8"); // Store the app ID state
  const [channel, setChannel] = useState(""); // Store the channel name state
  const [channelId, setChannelId] = useState("");
  const [token, setToken] = useState("");
  const timeoutRef = useRef(null);
    

  //Timer
  const [seconds, setSeconds] = useState(0);
  const timerRef = useRef(null);
  const secondsRef = useRef(0); // Ref to hold the latest value of seconds

  const startTimer = () => {
    if (!timerRef.current) {
      timerRef.current = setInterval(() => {
        setSeconds((prev) => {
          const newSeconds = prev + 1;
          secondsRef.current = newSeconds; // Update the ref with the latest value
          return newSeconds;
        });
      }, 1000);
    }
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  //Both user details state
  const [senderId, setSenderId] = useState("");
  const [receiverId, setReceiverId] = useState("");
  const [callerName, setCallerName] = useState("");

  useEffect(() => {
    startAgora();
  }, []);

  const startTimeout = async () => {
      try {
        const response = await GetUserByIdApi();
        const videoTalkTime = response.videoTalkTime;
        console.log('VideoTalkTime AutoCut', videoTalkTime);
        timeoutRef.current = setTimeout(() => {
          Leave();
          stopTimer();
          alert('You have no Talktime Left Please Recharge');
        }, videoTalkTime * 1000);
      } catch (error) {
        console.error('Error fetching timeout value:', error);
      }
    };
  
    const stopTimeout = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };


  const startAgora = async () => {
    const response = await AgoraStartApi();

    if (response) {
      console.log("AgoraStartApi response:", response);
      setChannel(response.channelName);
      setToken(response.token);
      setChannelId(response.channelId);
      setCalling(true);
    }
  };

  const friendDetails = async () => {
    const response = await GetFriendDetailsApi(channelId);
    let senderId = "",
      receiverId = "",
      callerName = "";
    if (response.callerName === name) {
      senderId = String(response.callerid);
      receiverId = String(response.receiverid);
      callerName = String(response.receiverName);
    } else {
      senderId = String(response.receiverid);
      receiverId = String(response.callerid);
      callerName = String(response.callerName);
    }
    setSenderId(senderId);
    setReceiverId(receiverId);
    setCallerName(callerName);
  };

  useJoin(
    { appid: appId, channel: channel, token: token ? token : null },
    calling
  );
  const [micOn, setMic] = useState(true);
  const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
  usePublish([localMicrophoneTrack]);
  const remoteUsers = useRemoteUsers();
  // User Joined Event
  useEffect(() => {
    remoteUsers.forEach((user) => {
      if (user.hasAudio) {
        setWave(false);
        user.audioTrack?.play(); // Play remote user's audio
        friendDetails();
        startTimer();
        startTimeout()
      }
    });


    // User Left Event
    if (remoteUsers.length === 0 && calling) {
      // console.log("Remote user has left the call.");
      stopTimer();
      Leave();
    }
  }, [remoteUsers]);

  // useClientEvent(client, "user-left", () => {

  //   Leave();
  // });



  const Leave = async () => {
    await friendDetails();
    const response = await AgoraEndApi({ time: seconds,isVideo:false });
    console.log("AgoraEndApi response:", response);
    if (response) {
      
      if (wave) {
        navigate("/", { replace: true });
        stopTimeout()
        return;
      }
      console.log(
        "Sending props to RatingPage senderId",
        senderId,
        "receiverId",
        receiverId
      );
      stopTimeout()

      navigate("/rate", {
        replace: true,
        state: {
          senderId: senderId,
          receiverId: receiverId,
          callerName: callerName,
        },
      });
    } else {
      stopTimeout()
      navigate("/", { replace: true });
    }
  };

  const waveComponent = () => {
    return (
      <div className="talking-wave-component-container">
        <CircularWaveAnimation />
      </div>
    );
  };

  const notWaveComponent = () => {
    return (
      <>
        <div className="talking-not-wave-component-container">
          <div className="talking-profile-image-text">
            <img
              src={maleProfileImage}
              className="talking-profile-image"
              alt="Good-People"
            />
            <h3 className="talking-header-text">{name ? name : ""}</h3>
          </div>
          <img
            src={micImageImage}
            className="talking-mic-image"
            alt="Good-People"
          />
          <div className="talking-profile-image-text">
            <img src={femaleProfileImage} className="talking-profile-image" />
            <h3 className="talking-header-text">
              {callerName ? callerName : ""}
            </h3>
          </div>
        </div>
        <h3 className="talking-page-timer-text">Timer:{FormatTime(seconds)}</h3>
      </>
    );
  };

  const handleMicClick = async () => {
    try {
      if (!localMicrophoneTrack) {
        console.warn("Local microphone track not initialized.");
        return;
      }

      if (isMute) {
        // Unmute microphone
        await localMicrophoneTrack.setEnabled(true);
        console.log("Microphone unmuted");
      } else {
        // Mute microphone
        await localMicrophoneTrack.setEnabled(false);
        console.log("Microphone muted");
      }

      setIsMute(!isMute); // Toggle the mute state
    } catch (error) {
      console.error("Error toggling microphone state:", error);
    }
  };

  const footerComponent = () => {
    return (
      <div className="talking-footer-container">
        <button onClick={handleMicClick} className="talking-footer-button">
          <img
            src={isMute ? micOffImage : micOnImage}
            className="talking-footer-icon"
            alt="Good-People"
          />
        </button>
        <button onClick={Leave} className="talking-footer-button">
          <img
            src={callCutImage}
            className="talking-footer-icon"
            alt="Good-People"
          />
        </button>
        
      </div>
    );
  };

  return (
    <div>
      <div className="talking-header-container">
        <h1 className="talking-header-text">{headerText}</h1>
      </div>
      {remoteUsers.map((user) => (
        <div key={user.uid}>
          <RemoteUser user={user}>
            <samp>{user.uid}</samp>
          </RemoteUser>
        </div>
      ))}
      <div className="talking-change-quotes-button-container">
        {wave ? (
          <div className="talking-finding-friend-container">
            <img
              src={searchImage}
              className="talking-search-icon"
              alt="Good-People"
            />
            <h3>Finding a friend for you!</h3>
          </div>
        ) : (
          <button
            onClick={() => alert("Button clicked!")}
            className="talking-change-quotes-button"
          >
            <h3>Change Quotes</h3>
            <img
              src={reloadImage}
              className="talking-reload-icon"
              alt="Good-People"
            />
          </button>
        )}
      </div>

      <PromoBanner />
      {wave ? waveComponent() : notWaveComponent()}
      {footerComponent()}
    </div>
  );
};

export default TalkingPage;
